// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/management/api/user.proto (package gx.management.api, syntax proto3)
/* eslint-disable */

import { UserService } from "./user_pb.js";

/**
 * @generated from rpc gx.management.api.UserService.GetCurrentUser
 */
export const getCurrentUser = UserService.method.getCurrentUser;

/**
 * @generated from rpc gx.management.api.UserService.GetUser
 */
export const getUser = UserService.method.getUser;

/**
 * @generated from rpc gx.management.api.UserService.GetUserTenants
 */
export const getUserTenants = UserService.method.getUserTenants;

/**
 * @generated from rpc gx.management.api.UserService.UpdateCurrentUser
 */
export const updateCurrentUser = UserService.method.updateCurrentUser;

/**
 * @generated from rpc gx.management.api.UserService.DeleteUser
 */
export const deleteUser = UserService.method.deleteUser;
